<template>
<div v-if="team.length && user_ids.length" class="d-flex align-items-center justify-content-start gap-1" style="flex-wrap: wrap">
    <img v-for="user in shown_users" :key="user.id" :src="user | avatar_url" class="rounded fit-cover" :class="[img_cls]" v-popover="`${user.name}`" />
    <a href="#" @click.prevent="show_all=true" v-if="!show_all && user_ids.length > shown_users.length" :class="[img_cls]" class="bg-blue-grey-300 text-white rounded d-flex align-items-center justify-content-center text-sm"><span>+{{ user_ids.length - shown_users.length }}</span></a>
</div>
</template>
<script lang="js">

/**
 * List of team member avatars, with tooltips of their names.
 * Utils.avatar_url is used to generate the avatar image.
 * Does not show members who are not in the `team` props (e.g., previous members who had been deleted)
 * By default shows the first 4 avatars and a "+" button to show all. You can override this limit
 * with the `avatars_shown` prop.
 * The default avatar size is thumb40, you can override it with `img_cls`
 */

export default {

    props: {
        // List of user objects to choose from
        team: {
            type: Array,
            default: () => []
        },

        // Which users to list
        user_ids: {
            type: Array,
            default: () => []
        },

        // How many avatars are shown. If there are more, a "+x" button is shown that expands the list to show all
        avatars_shown: {
            type: Number,
            default: 4
        },

        img_cls: {
            type: String,
            default: "thumb40 "
        }

    },

    data(){
        return {
            show_all: false
        }
    },

    computed: {

        selected_users(){
            return this.team.filter(user => this.user_ids.includes(user.id))
        },

        shown_users(){
            if(this.show_all) return this.selected_users

            if(this.selected_users.length <= this.avatars_shown) return this.selected_users.slice(0, this.avatars_shown)
            return this.selected_users.slice(0, this.avatars_shown-1)
        },

    },
}
</script>